export default __webpack_public_path__ + "static/SilverNavy-3d73f074d479f31d4a4f08827378e37a.svg";